import { render, staticRenderFns } from "./WizardCreate.vue?vue&type=template&id=1d932b5e"
import script from "./WizardCreate.vue?vue&type=script&lang=js"
export * from "./WizardCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports